import axios from 'axios'
import cookie from 'react-cookies'
import imageCompression from 'browser-image-compression'
import { notify } from 'react-notify-toast'
import ApiURL from './ApiUrl'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import { getOffset } from '../utils/timeOffset'

// import { apiCall } from './base'

// GET VIDEOS WATCHED BY USER
export const getAllUserWatchedVideos = async (isThispaidFolder) => {
  const endpointUrl = isThispaidFolder ? 'videostatuschallange' : 'videostatus'
  let allWatchedVideos

  const getAllWatchedVideosConfig = {
    method: 'get',
    url: `${ApiURL}/api/${endpointUrl}/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getAllWatchedVideosConfig)
    .then((response) => {
      allWatchedVideos = response.data
    })
    .catch((error) => {
      if (error.status == 401) {
        // refreshToken()
        // getAllUserWatchedVideos()
      }
    })

  return allWatchedVideos
}

// GET ALL VIDEOS FROM PASSED ALBUM PATH

// GET ALL USER WATCHED VIDEOS FROM PASSED FOLDER
export const getAllUserWatchedVideosByFolder = async (
  folderId,
  isThisPaidFolder
) => {
  let watchedVideosFromFolder
  const endpointurl = isThisPaidFolder ? 'videostatuschallange' : 'videostatus'

  const getAllUserWatchedVideosByFolderConfig = {
    method: 'GET',
    url: `${ApiURL}/api/${endpointurl}/?album_id=${folderId}`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getAllUserWatchedVideosByFolderConfig)
    .then((response) => {
      watchedVideosFromFolder = response.data
    })
    .catch((error) => {
      if (error.status == 401) {
        // refreshToken()
        // getAllUserWatchedVideosByFolder(folderId)
      }
    })
  return watchedVideosFromFolder
}

export const getSpecificVideoStatus = async (videoId, isThisPaidFolder) => {
  let specificVideo
  const endpointurl = isThisPaidFolder ? 'videostatuschallange' : 'videostatus'

  const getSpecificVideoStatusConfig = {
    method: 'get',
    url: `${ApiURL}/api/${endpointurl}/?video_id=${videoId}`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getSpecificVideoStatusConfig)
    .then((response) => {
      specificVideo = response.data
    })
    .catch((error) => {
      if (error.status == 401) {
        // refreshToken()
        // getAllUserWatchedVideosByFolder(folderId)
      }
    })

  return specificVideo
}

export const getAllUserStatusesForPaidContent = async () => {
  let allPaidContentStatuses

  const getAllPaidContentStatusesConfig = {
    method: 'get',
    url: `${ApiURL}/api/videostatus/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getAllPaidContentStatusesConfig)
    .then((response) => {
      allPaidContentStatuses = response.data
    })
    .catch((error) => {
      if (error.status == 401) {
        // refreshToken()
        // getAllUserWatchedVideos()
      }
    })

  return allPaidContentStatuses
}

export const getSingleVideo = async () => {
  let singleVideo
  const getSingleVideoConfig = {
    method: 'GET',
    url: `${ApiURL}/api/vimeovideos/videos/${371489741}`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getSingleVideoConfig)
    .then((response) => {
      singleVideo = response.data
    })
    .catch(({ error, response }) => {
      console.log(error)

      if (error.status == 401) {
        // refreshToken()
        // this.getSingleVideo()
      } else {
        console.log(error)
      }
    })
  return singleVideo
}

// New endpoint

export const getAllAlbumVideos = async (albumId, mode) => {
  let albumVideos

  const offset = getOffset()

  const getAllAlbumVideosConfig = {
    method: 'GET',
    url: `${ApiURL}/api/vimeovideos/vimeo_actions/videos/?vimeo_album_id=${albumId}&offset_ms=${offset}`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getAllAlbumVideosConfig)
    .then((response) => {
      albumVideos = response.data

      if (mode == 'nutshell') {
        albumVideos = response.status
      }
    })
    .catch(({ error, response }) => {
      if (response.status === 402) {
        albumVideos = 402
      }

      if (response.status === 425) {
        albumVideos = 425
      }
      // if (error.status == 401) {
      //   // refreshToken()
      //   // this.getSingleVideo()
      // } else {
      //   console.log(error)
      // }
    })
  return albumVideos
}

export const getSpecificVideo = async (videoId) => {
  let singleVideo
  const getSingleVideoConfig = {
    method: 'GET',
    url: `${ApiURL}/api/vimeovideos/videos/${videoId}`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getSingleVideoConfig)
    .then((response) => {
      singleVideo = response.data

      this.setState({
        video: response.data,
      })
    })
    .catch(({ error, response }) => {})

  return singleVideo
}
// export const getSingleVideo = async (videoId) => {
//   let singleVideo
//   const getSingleVideoConfig = {
//     method: 'GET',
//     url: `${ApiURL}/api/vimeovideos/videos/${videoId}`,
//     headers: {
//       Authorization: 'Bearer ' + cookie.load('accessToken'),
//     },
//   }

//   await axios(getSingleVideoConfig)
//     .then((response) => {
//       singleVideo = response.data
//     })
//     .catch(({ error, response }) => {
//       console.log(error)

//       // if (error.status == 401) {
//       //   refreshToken()
//       //   // this.getSingleVideo()
//       // } else {
//       //   console.log(error)
//       // }
//     })
//   return singleVideo
// }

// export const getSingleVideo = async (videoId) => {
//   let singleVideo

//   await axios
//     .get(`${ApiURL}/api/vimeovideos/videos/${videoId}`, {
//       headers: {
//         Authorization: 'Bearer ' + cookie.load('accessToken'),
//       },
//     })
//     .then((response) => {
//       if (response.data) {
//         singleVideo = response.data
//       }
//     })

//     // return userData

//     .catch((error) => {
//       console.log(error)
//     })

//   return singleVideo
// }

export const setVideoStatus = async (albumId, videoId, videoOrder) => {
  const setVideoStatusConfig = {
    method: 'post',
    url: `${ApiURL}/api/videostatus/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    data: {
      album__id: albumId + 6,
      video_order_id: videoOrder,
      video_id: videoId,
      is_intro: videoOrder === 0,
    },
  }

  await axios(setVideoStatusConfig)
    .then((response) => {})
    .catch((error) => {
      console.log(error)
    })
}

export const setTemporaryVideoStatus = async (albumId, videoId, videoOrder) => {
  let vidStatus
  const setVideoStatusConfig = {
    method: 'post',
    url: `${ApiURL}/api/vimeovideos/temporary_video_statuses/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    data: {
      album: albumId,
      video_id: videoId,
      video_order_id: videoOrder,
    },
  }

  await axios(setVideoStatusConfig)
    .then((response) => {
      vidStatus = response
    })
    .catch((error) => {
      console.log(error)
    })

  return vidStatus
}

export const getTemporaryVideoStatus = async (videoId, albumId) => {
  let tempVidStatus
  const getSingleVideoConfig = {
    method: 'GET',
    url: `${ApiURL}/api/vimeovideos/temporary_video_statuses/status_detail/?video_id=${videoId}&album_id=${albumId}`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getSingleVideoConfig)
    .then((response) => {
      tempVidStatus = response.data

      this.setState({
        video: response.data,
      })
    })
    .catch(({ error, response }) => {})

  return tempVidStatus
}

export const toggleFavoriteVideo = async (videoId, albumId) => {
  const setVideoFavoriteConfig = {
    method: 'POST',
    url: `${ApiURL}/api/favorites/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    data: {
      vimeo_album_id: parseInt(albumId),
      video_id: videoId,
    },
  }

  await axios(setVideoFavoriteConfig).then((response) => {
    if (
      response.status == 200 ||
      response.status == 201 ||
      response.status == 204
    ) {
      if (response.status == 201) {
        notify.show(`Trening został dodany do listy ulubionych`, 'success')
      }

      notify.show(`${response.data.detail}`, 'success')
    } else {
    }
  })
}

export const standardVideoCreateStatus = async (
  albumId,
  videoId,
  videoOrder
) => {
  let vidStatus
  const setVideoStatusConfig = {
    method: 'post',
    url: `${ApiURL}/api/general_video_statuses/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    data: {
      album_vimeo_id: albumId,
      video_vimeo_id: videoId,
      video_order: videoOrder,
    },
  }

  await axios(setVideoStatusConfig)
    .then((response) => {
      vidStatus = response
    })
    .catch((error) => {
      console.log(error)
    })

  return vidStatus
}

export const getStandardVideoStatus = async (videoId, albumId) => {
  let standardVideoStatus
  const getSingleVideoConfig = {
    method: 'GET',
    url: `${ApiURL}/api/general_video_statuses/status_detail/?video_id=${videoId}&album_id=${albumId}`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getSingleVideoConfig)
    .then((response) => {
      standardVideoStatus = response.data
    })
    .catch(({ error, response }) => {})

  return standardVideoStatus
}

export const setStandardVideoLocked = async (statusId) => {
  const setVideoStatusConfig = {
    method: 'post',
    url: `${ApiURL}/api/general_video_statuses/${statusId}/set_as_locked/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(setVideoStatusConfig)
    .then((response) => {})
    .catch((error) => {
      console.log(error)
    })
}

export const setStandardVideoWatched = async (statusId) => {
  const setVideoStatusConfig = {
    method: 'post',
    url: `${ApiURL}/api/general_video_statuses/${statusId}/set_as_locked/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(setVideoStatusConfig)
    .then((response) => {})
    .catch((error) => {
      console.log(error)
    })
}
